<div class="page-container">
  <nz-spin [nzSpinning]="loading" [testId]="'tenant-basic-info-spin'">
    <div class="page-shell">
      <div class="page-toolbar" [testId]="'tenant-basic-info-header'">
        <div class="page-heading">
          <h3 class="page-title" [testId]="'tenant-basic-info-title'">{{ 'tenant.detail.basic-info' | i18n }}</h3>
          <p class="page-subtitle" [testId]="'tenant-basic-info-subtitle'">{{ 'tenant.config.basic-info-subtitle' | i18n }}</p>
        </div>

        <button
          nz-button
          nzType="primary"
          type="button"
          class="save-button"
          (click)="saveTenant()"
          [nzLoading]="loading"
          [testId]="'tenant-basic-info-save-button'"
        >
          <i nz-icon nzType="save"></i>
          {{ 'tenant.config.save-changes' | i18n }}
        </button>
      </div>

      <div class="unsaved-banner" *ngIf="hasUnsavedChanges" [testId]="'tenant-basic-info-unsaved-banner'">
        <i nz-icon nzType="exclamation-circle"></i>
        <span>{{ 'tenant.config.unsaved-banner' | i18n }}</span>
      </div>

      <div class="form-container" [testId]="'tenant-basic-info-scroll'">
        <section class="overview-card" [testId]="'tenant-basic-info-overview'">
          <div class="overview-main">
            <div class="avatar-wrap">
              <nz-avatar
                class="tenant-avatar"
                [nzSrc]="avatarUrl"
                [nzSize]="72"
                nzIcon="user"
                (click)="openImageViewer()"
                [testId]="'tenant-basic-info-avatar'"
              />
              <button
                nz-button
                nzType="default"
                nzShape="circle"
                class="avatar-edit-btn"
                type="button"
                (click)="showAvatarUploadModal()"
                [testId]="'tenant-basic-info-avatar-edit'"
              >
                <i nz-icon nzType="edit"></i>
              </button>
            </div>

            <div class="overview-copy">
              <div class="tenant-name">{{ tenantForm.get('name')?.value || tenantData?.name || '-' }}</div>
              <div class="overview-helper">{{ 'tenant.config.image-note-hint' | i18n }}</div>
            </div>
          </div>
        </section>

        <form nz-form nzLayout="vertical" [formGroup]="tenantForm" class="info-form" [testId]="'tenant-basic-info-form'">
          <div class="form-grid">
            <div class="form-field">
              <nz-form-item>
                <nz-form-label nzRequired>{{ 'tenant.detail.tenant-name' | i18n }}</nz-form-label>
                <nz-form-control [nzErrorTip]="'tenant.detail.error.tenant-name' | i18n">
                  <input
                    nz-input
                    formControlName="name"
                    [placeholder]="'tenant.detail.placeholder.tenant-name' | i18n"
                    testId="tenant-basic-info-name-input"
                  />
                </nz-form-control>
              </nz-form-item>
            </div>

            <div class="form-field">
              <nz-form-item>
                <nz-form-label nzRequired>{{ 'tenant.detail.tenant-short-name' | i18n }}</nz-form-label>
                <nz-form-control [nzErrorTip]="'tenant.detail.error.tenant-short-name' | i18n">
                  <input
                    nz-input
                    formControlName="shortName"
                    [placeholder]="'tenant.detail.placeholder.tenant-short-name' | i18n"
                    testId="tenant-basic-info-short-name-input"
                  />
                </nz-form-control>
              </nz-form-item>
            </div>

            <div class="form-field">
              <nz-form-item>
                <nz-form-label nzRequired>{{ 'tenant.detail.tenant-code' | i18n }}</nz-form-label>
                <nz-form-control>
                  <input
                    nz-input
                    formControlName="code"
                    [placeholder]="'tenant.detail.placeholder.tenant-code' | i18n"
                    class="readonly-field"
                    readonly
                    testId="tenant-basic-info-code-input"
                  />
                  <div class="field-hint">{{ 'tenant.config.company-code-hint' | i18n }}</div>
                </nz-form-control>
              </nz-form-item>
            </div>

            <div class="form-field">
              <nz-form-item>
                <nz-form-label nzRequired>{{ 'tenant.detail.tenant-type-label' | i18n }}</nz-form-label>
                <nz-form-control>
                  <nz-select
                    formControlName="type"
                    [nzPlaceHolder]="'tenant.detail.placeholder.tenant-type-readonly' | i18n"
                    [nzDisabled]="true"
                    testId="tenant-basic-info-type-select"
                  >
                    <nz-option *ngFor="let type of tenantTypes; trackBy: trackByValue" [nzValue]="type.value" [nzLabel]="type.label" />
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>

            <div class="form-field">
              <nz-form-item>
                <nz-form-label>{{ 'tenant.detail.industry-type' | i18n }}</nz-form-label>
                <nz-form-control>
                  <nz-select
                    nzAllowClear
                    formControlName="industry"
                    [nzPlaceHolder]="'tenant.detail.placeholder.industry-type' | i18n"
                    (ngModelChange)="updateIndustrySubOptions($event)"
                    testId="tenant-basic-info-industry-select"
                  >
                    <nz-option *ngFor="let item of industryOptions; trackBy: trackByValue" [nzValue]="item.value" [nzLabel]="item.text" />
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>

            <div class="form-field">
              <nz-form-item>
                <nz-form-label>{{ 'tenant.detail.industry-sub-type' | i18n }}</nz-form-label>
                <nz-form-control>
                  <nz-select
                    nzAllowClear
                    formControlName="industrySub"
                    [nzPlaceHolder]="'tenant.detail.please-select-sub-type' | i18n"
                    testId="tenant-basic-info-industry-sub-select"
                  >
                    <nz-option
                      *ngFor="let item of industrySubOptions; trackBy: trackByValue"
                      [nzValue]="item.value"
                      [nzLabel]="item.text"
                    />
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>

            <div class="form-field">
              <nz-form-item>
                <nz-form-label>{{ 'tenant.detail.company-scale' | i18n }}</nz-form-label>
                <nz-form-control>
                  <nz-select
                    formControlName="scale"
                    [nzPlaceHolder]="'tenant.detail.placeholder.company-scale' | i18n"
                    nzAllowClear
                    testId="tenant-basic-info-scale-select"
                  >
                    <nz-option *ngFor="let item of scaleOptions; trackBy: trackByValue" [nzValue]="item.value" [nzLabel]="item.text" />
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>

            <div class="form-field">
              <nz-form-item>
                <nz-form-label>{{ 'tenant.detail.associated-account' | i18n }}</nz-form-label>
                <nz-form-control>
                  <input
                    nz-input
                    formControlName="accountId"
                    [placeholder]="'tenant.detail.placeholder.associated-account' | i18n"
                    class="readonly-field"
                    readonly
                    testId="tenant-basic-info-account-id-input"
                  />
                </nz-form-control>
              </nz-form-item>
            </div>

            <div class="form-field">
              <nz-form-item>
                <nz-form-label>{{ 'tenant.detail.start-time' | i18n }}</nz-form-label>
                <nz-form-control>
                  <nz-date-picker
                    formControlName="startTime"
                    nzFormat="yyyy-MM-dd"
                    style="width: 100%"
                    (ngModelChange)="onStartTimeChange()"
                    testId="tenant-basic-info-start-time-picker"
                  />
                </nz-form-control>
              </nz-form-item>
            </div>

            <div class="form-field">
              <nz-form-item>
                <nz-form-label>{{ 'tenant.detail.end-time' | i18n }}</nz-form-label>
                <nz-form-control [nzErrorTip]="endTimeErrorTpl">
                  <nz-date-picker
                    formControlName="endTime"
                    nzFormat="yyyy-MM-dd"
                    style="width: 100%"
                    testId="tenant-basic-info-end-time-picker"
                  />
                  <ng-template #endTimeErrorTpl let-control>
                    <ng-container *ngIf="control.hasError('endTimeInvalid')">{{
                      'tenant.detail.error.end-time-invalid' | i18n
                    }}</ng-container>
                  </ng-template>
                </nz-form-control>
              </nz-form-item>
            </div>

            <div class="form-field">
              <nz-form-item>
                <nz-form-label>{{ 'tenant.detail.unified-number' | i18n }}</nz-form-label>
                <nz-form-control>
                  <input
                    nz-input
                    formControlName="unifiedNumber"
                    [placeholder]="'tenant.detail.placeholder.unified-number' | i18n"
                    testId="tenant-basic-info-unified-number-input"
                  />
                </nz-form-control>
              </nz-form-item>
            </div>

            <div class="form-field">
              <nz-form-item>
                <nz-form-label>{{ 'tenant.detail.company-representative-number' | i18n }}</nz-form-label>
                <nz-form-control>
                  <input
                    nz-input
                    formControlName="representativeNumber"
                    [placeholder]="'tenant.detail.placeholder.company-representative-number' | i18n"
                    testId="tenant-basic-info-representative-number-input"
                  />
                </nz-form-control>
              </nz-form-item>
            </div>

            <div class="form-field">
              <nz-form-item>
                <nz-form-label>{{ 'tenant.detail.company-website' | i18n }}</nz-form-label>
                <nz-form-control>
                  <input
                    nz-input
                    formControlName="website"
                    [placeholder]="'tenant.detail.placeholder.company-website' | i18n"
                    testId="tenant-basic-info-website-input"
                  />
                  <div class="field-hint">{{ 'tenant.config.website-hint' | i18n }}</div>
                </nz-form-control>
              </nz-form-item>
            </div>

            <div class="form-field">
              <nz-form-item>
                <nz-form-label>{{ 'tenant.detail.company-address' | i18n }}</nz-form-label>
                <nz-form-control>
                  <nz-select
                    formControlName="city"
                    [nzPlaceHolder]="'tenant.detail.placeholder.company-address' | i18n"
                    nzAllowClear
                    testId="tenant-basic-info-city-select"
                  >
                    <nz-option *ngFor="let item of cityOptions; trackBy: trackByValue" [nzValue]="item.value" [nzLabel]="item.text" />
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>

            <div class="form-field span-2">
              <nz-form-item>
                <nz-form-label>{{ 'tenant.detail.contact-address' | i18n }}</nz-form-label>
                <nz-form-control>
                  <input
                    nz-input
                    formControlName="address"
                    [placeholder]="'tenant.detail.placeholder.contact-address' | i18n"
                    testId="tenant-basic-info-address-input"
                  />
                </nz-form-control>
              </nz-form-item>
            </div>

            <div class="form-field span-2">
              <nz-form-item>
                <nz-form-label nzRequired>{{ 'tenant.detail.tenant-description' | i18n }}</nz-form-label>
                <nz-form-control [nzErrorTip]="'tenant.detail.error.tenant-description' | i18n">
                  <textarea
                    nz-input
                    formControlName="description"
                    [placeholder]="'tenant.detail.placeholder.tenant-description' | i18n"
                    rows="4"
                    testId="tenant-basic-info-description-textarea"
                  ></textarea>
                  <div class="field-hint">{{ 'tenant.config.description-hint' | i18n }}</div>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
        </form>
      </div>
    </div>
  </nz-spin>
</div>

<avatar-upload-modal
  [visible]="isAvatarModalVisible"
  [uploading]="isAvatarUploading"
  (cancel)="handleAvatarModalCancel()"
  (ok)="handleAvatarCropped($event)"
/>

<image-viewer
  [visible]="imageViewerVisible"
  [imageUrl]="avatarUrl"
  [title]="'tenant.detail.image-preview' | i18n"
  (close)="closeImageViewer()"
/>
